import { IIntegratedCare } from '@alberta/konexi-shared';
import { Component, EventEmitter } from '@angular/core';
import { ISelectModalComponent } from 'src/app/shared/components/common/select-modal/select-modal-component';

import { IIntegratedTherapyTypeInfo } from '../integratedcare-therapy-type-info';

@Component({
  selector: 'itl-select-integrated-care',
  templateUrl: './select-integrated-care.component.html',
  styleUrls: ['./select-integrated-care.component.scss'],
})
export class SelectIntegratedCareComponent implements ISelectModalComponent {
  public componentProps: any;
  public orderSelected = false;
  public seriesOrderSelected = false;
  public valueChange: EventEmitter<any> = new EventEmitter<any>();
  public therapyTypeInfos: IIntegratedTherapyTypeInfo[] = [];
  public showTherapies = false;
  public integratedCares: IIntegratedCare[] = [];

  public selectTherapy($event: any, selectedIntegratedCare: IIntegratedCare) {
    if ($event.target.checked) {
      this.integratedCares.push(selectedIntegratedCare);
      if (this.componentProps.maxAmount) {
        if (this.integratedCares.length && this.integratedCares.length <= this.componentProps.maxAmount) {
          this.valueChange.emit(this.integratedCares);
        } else {
          this.valueChange.emit(null);
        }
      } else if (this.integratedCares.length) {
        this.valueChange.emit(this.integratedCares);
      }
    } else {
      this.integratedCares = this.integratedCares.filter(
        integratedCare => integratedCare._id !== selectedIntegratedCare._id
      );
      if (this.componentProps.maxAmount) {
        if (this.integratedCares.length && this.integratedCares.length <= this.componentProps.maxAmount) {
          this.valueChange.emit(this.integratedCares);
        }
        if (this.integratedCares.length && this.integratedCares.length > this.componentProps.maxAmount) {
          this.valueChange.emit(null);
        }
        if (!this.integratedCares.length) {
          this.valueChange.emit(null);
        }
      } else {
        if (this.integratedCares.length) {
          this.valueChange.emit(this.integratedCares);
        }
        if (!this.integratedCares.length) {
          this.valueChange.emit(null);
        }
      }
    }
  }
}
